export default "__VITE_ASSET__zQUJRDpd__"